import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons';
import { Marker } from '@react-google-maps/api';
import { FC, useState } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';
import { ListTicket, TicketStatus } from 'src/store/models/Ticket';
import { colors } from 'src/utils/colors';

import MarkerInfo from '../MarkerInfo/MarkerInfo';

export interface MapMarkerProps {
  position: google.maps.LatLng;
  ticket: ListTicket;
  onClick?: (ticket: ListTicket) => void;
}

const MapMarker: FC<MapMarkerProps> = ({ position, ticket, onClick }) => {
  const user = useAppSelector((state) => state.auth.user);
  const isService = user?.role === Role.SERVICE;
  const isManufacturer = user?.role === Role.MANUFACTURER;

  const [open, setOpen] = useState(false);
  const status = ticket.status;

  const iconSize = !open ? 0.035 : 0.045;
  const iconFill =
    status === TicketStatus.TO_DO && isManufacturer
      ? colors()?.colorBlack
      : (status === TicketStatus.TO_DO && isService) ||
        (status === TicketStatus.UNASSIGNED && isManufacturer)
      ? colors()?.colorRed
      : status === TicketStatus.IN_PROGRESS
      ? colors()?.colorYellow
      : colors()?.colorFumisGreen1;

  return (
    <Marker
      icon={{
        path: faMapMarkerAlt.icon[4] as string,
        anchor: new google.maps.Point(
          faMapMarkerAlt.icon[0] / 2,
          faMapMarkerAlt.icon[1]
        ),
        scale: iconSize,
        fillColor: iconFill,
        fillOpacity: 1,
      }}
      animation={google.maps.Animation.DROP}
      position={position}
      onMouseOver={() => setOpen(true)}
      onMouseOut={() => setOpen(false)}
      onClick={() => onClick?.(ticket)}
      onDrag={() => setOpen(false)}
    >
      <MarkerInfo
        position={position}
        open={open}
        ticket={ticket}
        setOpen={setOpen}
      />
    </Marker>
  );
};

export default MapMarker;
